import { Suspense, lazy, useEffect, useState } from "react";
import {
  Navigate,
  Outlet,
  Route,
  BrowserRouter as Router,
  Routes,
} from "react-router-dom";
import "./styles.scss";
import "./global.css";
import { Provider } from "react-redux";
import store from "./store/index.ts";

import "./common/styles/common.scss";
import Loader from "./common/components/Loader/index.tsx";
import ProtectedRoute from "./layouts/protectedRoute.tsx";
import RoleBasedRoute from "./layouts/RoleBasedRoute.tsx";
import { getCallWithoutAuth } from "./services/apiService.ts";
import { endPoints } from "./constants/urlConstants.ts";
import { setItemInLocalStorage } from "./services/localStorage.ts";
import VerifySeekerPhoneNumberNew from "./pages/PhonenumberVerifyOld/index.tsx";
import useOnlineStatus from "./hooks/useOnlineStatus.ts";
import NoInternetConnection from "./common/components/NoInternet/index.tsx";

const Header = lazy(() => import("./common/Header/index"));
// const Subheader = lazy(() => import("./common/Subheader/index"));
const LoginScreen = lazy(() => import("./pages/LoginScreen/index.tsx"));

const Zoom = lazy(() => import("./pages/Zoom/index.tsx"));
const VerifyUserFace = lazy(() => import("./pages/VerifyUserFace/index.tsx"));
const Profile = lazy(() => import("./pages/Profile/index.tsx"));
// const JoinWithOthers = lazy(
//   () => import("./components/JoinWithOthers/index.tsx"),
// );
const Redirect = lazy(() => import("./pages/Redirect/index.tsx"));
const VerifyPhonenumber = lazy(
  () => import("./pages/PhonenumberVerify/index.tsx"),
);
const FriendsAndFamilyV2 = lazy(
  () => import("./common/components/MembersList/index.tsx"),
);
const MySpace = lazy(() => import("./pages/MySpaceV2/index.tsx"));
const PortalNavigation = lazy(
  () => import("./components/PortalNavigation/index.tsx"),
);
// const FriendsAndFamily = lazy(
//   () => import("./pages/FriendsAndFamily/index.tsx"),
// );
const Unathorized = lazy(() => import("./pages/Unathorized/index.tsx"));

interface AppLayoutProps {
  type: string;
}

//App layout to render the nested routes with a subheader component
const AppLayout: React.FC<AppLayoutProps> = ({ type }) => {
  const isOnline = useOnlineStatus();

  if (!isOnline) {
    return <NoInternetConnection />;
  }

  return (
    <>
      <div className="layoutContainer">
        <PortalNavigation appType={type} />
        <div className="contentContainer">
          <Outlet /> {/* This will render the nested routes */}
        </div>
      </div>
    </>
  );
};

export default function App() {
  const isOnline = useOnlineStatus();
  const [loader, setLoader] = useState(true);
  {
    /* app config api */
  }
  useEffect(() => {
    // Only fetch configurations if online
    if (isOnline) {
      const handleConfigurations = () => {
        setLoader(true); // Show loader immediately when the API call starts
        getCallWithoutAuth(endPoints.appConfigurations)
          .then((response) => {
            if (response?.data?.statusCode === 200) {
              setItemInLocalStorage(
                "appConfigurations",
                JSON.stringify(response?.data?.data),
              );
            }
            setLoader(false); // Hide loader after processing the response
          })
          .catch((error) => {
            console.log(error, "error");
            setLoader(false); // Hide loader in case of an error
          });
      };
      handleConfigurations();
    } else {
      setLoader(false); // No need to show loader if offline
    }
  }, [isOnline, location.pathname]);

  if (loader) {
    return <Loader type="large" />;
  }

  // Show no internet component if offline
  if (!isOnline) {
    return <NoInternetConnection />;
  }

  return (
    <Provider store={store}>
      <Router>
        <div className="App">
          <Suspense fallback={<Loader type="large" />}>
            <Header />
            <div>
              <Routes>
                <Route
                  path="/"
                  element={<Navigate replace to="/infinipath" />}
                />
                <Route path="/login" element={<LoginScreen />} />
                <Route path="/verifyuserface" element={<VerifyUserFace />} />
                <Route element={<ProtectedRoute />}>
                  {/* Routes for seeker start here */}
                  <Route
                    path="/infinipath"
                    element={
                      <RoleBasedRoute
                        element={<AppLayout type="infinipath" />}
                        // allowedRoles={["viewer", "mahatria", "admin"]}
                      />
                    }
                  >
                    <Route index element={<MySpace />} />
                    <Route path="zoom" element={<Zoom />} />
                    <Route path="profile" element={<Profile />} />
                    <Route
                      path="joinwithothers"
                      element={<FriendsAndFamilyV2 />}
                    />
                    <Route path="redirect" element={<Redirect />} />
                    <Route
                      path="friendsandfamily"
                      element={<FriendsAndFamilyV2 />}
                    />
                    <Route
                      path="verifyphonenumber"
                      element={<VerifyPhonenumber />}
                    />
                    <Route
                      path="deleteaccount"
                      element={<VerifySeekerPhoneNumberNew />}
                    />
                    {/* <Route path="myspace" element={<MySpace />} /> */}

                    <Route path="verifyuserface" element={<VerifyUserFace />} />
                  </Route>
                  {/* Routes for seeker ends here */}
                  {/* Routes for Admin starts here */}
                  {/* <Route
                    path="/admin"
                    element={
                      <RoleBasedRoute
                        element={<AppLayout type="admin" />}
                        allowedRoles={["mahatria"]}
                      />
                    }
                  >
                    <Route path="home" element={<Admin />} />
                    <Route
                      path="createinfinipath"
                      element={<CreateMeeting />}
                    />
                    <Route path="viewanalytics" element={<ViewAnalytics />} />
                    <Route path="sessions" element={<TrackRegistrations />} />
                    <Route path="zoom" element={<Zoom />} />
                    <Route path="profile" element={<Profile />} />
                    <Route path="redirect" element={<Redirect />} />
                    <Route path="seekerslist" element={<MuiDataGrid />} />
                  </Route> */}
                  {/* Routes for Admin ends here */}
                </Route>
                <Route path="*" element={<LoginScreen />} />
                <Route path="/unauthorized" element={<Unathorized />} />
              </Routes>
            </div>
          </Suspense>
        </div>
      </Router>
    </Provider>
  );
}
